import React from 'react';

export default function LegalInfo() {
  return (
    <section id="legal-info">
      <p className="body-title mt-4">Painel de informações</p>
    </section>
  );
}
